import React from "react";
import {IonCol, IonList, IonRadio, IonRadioGroup, IonRow} from "@ionic/react";
import "../styles/userTable.css";

const UserTable = (props) => {

    const {data, onRadioChange, disabled} = props;

    return (
        <IonList>
            <IonRadioGroup onIonChange={onRadioChange} disabled={disabled}>
                {Array.isArray(data) && data.map((item, idx) => {
                    const type = item?.attributes?.type?.[0] || '';
                    const email = item?.email || '';
                    const id = item?.id || '';
                    const firstName = item?.firstName || '';
                    const lastName = item?.lastName || '';
                    return (
                        <IonRow key={id || idx} className="users-row">
                            <IonCol className="table-cell radio-button">
                                <IonRadio value={JSON.stringify({ email, type, id, firstName, lastName })} disabled={disabled}/>
                            </IonCol>
                            <IonCol className="table-cell" >{firstName} {lastName}</IonCol>
                            <IonCol  className="table-cell">{email}</IonCol>
                            <IonCol  className="table-cell">{type}</IonCol>
                            
                        </IonRow>
                    );
                })}
            </IonRadioGroup>
        </IonList>
    );
}

export default UserTable;